<mwe-basic-card cardTitle="meterPoint.meterPointChangeRequest.pdfUpload.title" cardClass="ikp-basic-card-override" [hasBackground]="true">
  <div class="pt-0 pt-xl-3">
    <lib-ikp-file-input
      #fileUpload
      [config]="fileInputConfiguration"
      [hasMarginBottom]="true"
      (emitFileUpload)="fileUploaded($event)"
      dataTest="meterPointChangeRequest"
    />
  </div>
  @if (showLoadingSpinner()) {
    <mwe-loading-spinner />
  }
</mwe-basic-card>
